<template>
  <div class="wrapper border-bottom white-bg page-heading">

    <div class="container">
      <div class="row">
        <div class="col-md-6 col-lg-8">
          <heading-loading v-if="loading"></heading-loading>
          <h1 v-else><i class="far fa-clipboard-list m-r-sm"></i> {{ load.reference_number }}</h1>
        </div>
        <div class="col-md-6 col-lg-4" v-if="notLoading">
          <p class="job-status-header" :class="load.status_class">{{ load.status_text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { headingLoading } from 'mixins'

  export default {
    mixins: [headingLoading],

    computed: {
      ...mapGetters('load', { load: 'loadDecorated' })
    }
  }
</script>



// WEBPACK FOOTER //
// ShowHeading.vue?4cd736bb